import React from "react";

const StatsComponent = ({ data }) => {

    const matomoMetrics = data?.matomoMetrics || {};
    const pageViews = matomoMetrics['Pages vues'];

    if (!pageViews || typeof pageViews !== 'object' || Object.keys(pageViews).length === 0) {
        return (
            <div className="alert alert-light mb-0 p-1 rounded-1">
                <p className="mb-0 text-muted">Aucune statistique Matomo disponible pour cette page.</p>
            </div>
        );
    }

    const months = Object.keys(pageViews);

    return (
    <div className="alert alert-light mb-0 p-0 rounded-1">
       <table className="table">
            <thead className="table-light">
                <tr>
                    <th>Metric</th>
                    {months.map((month) => (
                        <th key={month}>{month}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {Object.entries(matomoMetrics).map(([metric, values]) => (
                    <tr key={metric}>
                        <td>{metric}</td>
                        {months.map((m) => {
                            const value = values?.[m];
                            return (
                                <td key={`${metric}-${m}`}>
                                    {typeof value === 'number' ? value.toLocaleString("fr-FR") : value}
                                </td>
                            );
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>

    );
}

export default StatsComponent;
